import { render } from "./TradeDetailsPVT.vue?vue&type=template&id=460ef30a&scoped=true"
import script from "./TradeDetailsPVT.vue?vue&type=script&lang=js"
export * from "./TradeDetailsPVT.vue?vue&type=script&lang=js"

import "./TradeDetailsPVT.vue?vue&type=style&index=0&id=460ef30a&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460ef30a"]])

export default __exports__